<template>
  <c-box
    v-if="isSearchOverlayVisible"
    :d="{ base: 'block', md: searchTerm.trim().length > 0 ? 'block' : 'none' }"
    background="rgba(0, 0, 0, 0.4)"
    position="fixed"
    left="0"
    right="0"
    bottom="0"
    :top="{ base: '52px', sm: '68px' }"
    z-index="popover"
    overflow="hidden"
    @click="hideGlobalSearchOverlay"
  >
    <c-box
      background="white"
      color="black"
      :width="{ base: '100%', md: '90%' }"
      maxWidth="1350px"
      mx="auto"
      mb="4xl"
      :pt="{ base: 'md', md: '42px' }"
      :px="{ base: 'xs', md: 0 }"
      @click.stop
    >
      <GlobalSearch></GlobalSearch>
    </c-box>
  </c-box>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapState } from "vuex";
import { CBox } from "@chakra-ui/vue";
import GlobalSearch from "@/components/globalSearch/GlobalSearchComponent.vue";
import { IGlobalSearchState } from "@/store/globalSearchModule";

export default defineComponent({
  name: "GlobalSearchOverlay",
  components: {
    CBox,
    GlobalSearch,
  },
  computed: {
    ...mapState("globalSearch", {
      searchTerm: (state: unknown) => (state as IGlobalSearchState).searchTerm,
      searchResults: (state: unknown) => (state as IGlobalSearchState).searchResults,
      isSearchOverlayVisible: (state: unknown) => (state as IGlobalSearchState).isOverlayVisible,
    }),
  },
  methods: {
    hideGlobalSearchOverlay() {
      this.$store.commit("globalSearch/setOverlayVisibility", false);
    },
  },
});
</script>
